/**
 * @description 操作日志 logOperation
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const logOperationBiz = new Logic()

logOperationBiz.findPage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logOperation.findPage,
    data: data
  })
}

export default logOperationBiz
